// @spec DHB-STR-035
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { ApprovalQueuePage } from '@/features/datahub/governance/ApprovalQueuePage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/datahub/governance/approval-queue')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.approvalQueue'),
  }),
  component: ApprovalQueuePage,
});
